export default __webpack_public_path__ + "static/media/cart.0a361b43.svg";